import { VariantSelected } from '@process-advisor/process-miner/processMiner/processMiner';
import { SidebarTab } from '@process-advisor/process-miner/shared/consts';
import { updateGauges } from '@process-advisor/process-miner/api/methods/slicers/updateGauges';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type SelectVariantProps = ApiMethodBase & {
    pane: SidebarTab,
    variant: number
};

export const selectVariant = ({
    eventEmitter,
    pane,
    variant,
}: SelectVariantProps) => {
    if (pane === SidebarTab.variantsTab) {
        updateGauges({ eventEmitter });
    }
    VariantSelected(variant);
};
